import React from "react";

import { ButtonStandard, ModalBase, Text } from "@performyard/py-components";

type ExitWizardModalProps = {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
	/** What the user loses by exiting, e.g. "Your workflow configuration will not be saved." */
	message: string;
};

/**
 * Shared confirmation for abandoning a wizard. Owned by the page rather than the
 * py-components `Wizard` so opening it can suppress the unsaved-changes blocker.
 */
export const ExitWizardModal = ({ isOpen, onClose, onConfirm, message }: ExitWizardModalProps) => (
	<ModalBase isOpen={isOpen} onClose={onClose} dangerouslySetClassName="w-[432px]">
		<div className="flex flex-col gap-6 px-6 pb-6">
			<div className="flex flex-col gap-0">
				<Text size="sub-heading" weight="semi-bold" dangerouslySetClassName="text-center">
					Exit Wizard
				</Text>
				<div className="flex flex-col gap-0 pr-6 pl-6">
					<Text size="paragraph-2" weight="regular" dangerouslySetClassName="text-center">
						{message}
					</Text>
				</div>
			</div>
			<div className="flex w-full flex-wrap justify-center gap-2">
				<ButtonStandard
					size="large"
					variant="outline"
					color="neutral"
					dangerouslySetClassName="w-auto px-[16px]"
					onClick={onClose}
				>
					Cancel
				</ButtonStandard>
				<ButtonStandard
					size="large"
					color="primary"
					dangerouslySetClassName="w-auto px-[16px]"
					onClick={onConfirm}
				>
					Yes, Exit Wizard
				</ButtonStandard>
			</div>
		</div>
	</ModalBase>
);
